// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * Favorite list item with last order metadata
 */
export const zFavoriteListItemDto = z.object({
    productId: z.optional(z.string()),
    lastOrderDate: z.optional(z.iso.datetime()),
    lastOrderQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    desiredQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

/**
 * Favorite list response including items
 */
export const zFavoriteListResponseDto = z.object({
    id: z.optional(z.uuid()),
    name: z.optional(z.string()),
    customerId: z.optional(z.string()),
    items: z.optional(z.array(zFavoriteListItemDto)),
    creationDate: z.optional(z.iso.datetime()),
    createdBy: z.optional(z.string()),
    lastModifiedDate: z.optional(z.iso.datetime()),
    lastModifiedBy: z.optional(z.string()),
    default: z.optional(z.boolean())
});

/**
 * Request payload to set desired quantity for a product in a favorite list
 */
export const zDesiredQuantityRequestDto = z.object({
    desiredQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zFavoriteListEditRquestDto = z.object({
    name: z.string().min(1)
});

export const zBaseOptionDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zCategoryDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zClassificationDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

/**
 * Representation of the sales unit
 */
export const zConversionDto = z.object({
    unit: z.optional(z.string()),
    factor: z.optional(z.string())
});

export const zMediqClassificationDto = z.object({
    code: z.optional(z.string()),
    values: z.optional(z.array(z.string()))
});

export const zProductDocumentDto = z.object({
    name: z.optional(z.string()),
    url: z.optional(z.string())
});

export const zProductNonInventoryPartDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zProductReferenceDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zProductSearchFacetResultBooleanDto = z.object({
    value: z.optional(z.boolean()),
    hits: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    selected: z.optional(z.boolean())
});

export const zProductSearchFacetResultValueDto = z.object({
    id: z.optional(z.string()),
    displayName: z.optional(z.string())
});

export const zProductSearchFacetResultDto = z.object({
    value: z.optional(zProductSearchFacetResultValueDto),
    hits: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    selected: z.optional(z.boolean())
});

export const zProductSearchFacetResultListDto = z.object({
    category: z.optional(z.array(zProductSearchFacetResultDto)),
    brand: z.optional(z.array(zProductSearchFacetResultDto)),
    stockAvailability: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    size: z.optional(z.array(zProductSearchFacetResultDto)),
    balloonVolume: z.optional(z.array(zProductSearchFacetResultDto)),
    carbAmount: z.optional(z.array(zProductSearchFacetResultDto)),
    ch: z.optional(z.array(zProductSearchFacetResultDto)),
    color: z.optional(z.array(zProductSearchFacetResultDto)),
    containsLatex: z.optional(z.array(zProductSearchFacetResultDto)),
    containsPvc: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    energyAmount: z.optional(z.array(zProductSearchFacetResultDto)),
    fatAmount: z.optional(z.array(zProductSearchFacetResultDto)),
    fiberAmount: z.optional(z.array(zProductSearchFacetResultDto)),
    material: z.optional(z.array(zProductSearchFacetResultDto)),
    numberOfWashes: z.optional(z.array(zProductSearchFacetResultDto)),
    proteinAmount: z.optional(z.array(zProductSearchFacetResultDto)),
    ceMarkedProduct: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    bisphenol: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    lanolin: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    phthalates: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    plasticizer: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    resin: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    sterile: z.optional(z.array(zProductSearchFacetResultBooleanDto)),
    environmentalCode: z.optional(z.array(zProductSearchFacetResultDto)),
    absorptionCapacity: z.optional(z.array(zProductSearchFacetResultDto)),
    taste: z.optional(z.array(zProductSearchFacetResultDto)),
    tip: z.optional(z.array(zProductSearchFacetResultDto)),
    tubingLength: z.optional(z.array(zProductSearchFacetResultDto))
});

export const zPromotionDto = z.object({
    code: z.optional(z.string()),
    title: z.optional(z.string()),
    description: z.optional(z.string())
});

export const zReviewDto = z.object({
    id: z.optional(z.string()),
    rating: z.optional(z.number()),
    comment: z.optional(z.string())
});

/**
 * Representation of a Unit
 */
export const zSapUnitDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string()),
    availabilityCode: z.optional(z.string()),
    sapCode: z.optional(z.string())
});

/**
 * Representation of the sales unit
 */
export const zSalesUnitsDto = z.object({
    code: z.optional(z.string()),
    defaultSalesUnit: z.optional(z.string()),
    salesUnitDescription: z.optional(z.string()),
    conversions: z.optional(z.array(zConversionDto))
});

export const zVariantMatrixElementDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zVariantOptionDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string())
});

export const zServerMessageDto = z.object({
    message: z.optional(z.string().min(0).max(255).regex(/^.{0,255}$/))
});

export const zProductSearchFacetDto = z.object({
    category: z.optional(z.array(z.string())),
    brand: z.optional(z.array(z.string())),
    stockAvailability: z.optional(z.array(z.boolean())),
    size: z.optional(z.array(z.string())),
    balloonVolume: z.optional(z.array(z.string())),
    carbAmount: z.optional(z.array(z.string())),
    ch: z.optional(z.array(z.string())),
    color: z.optional(z.array(z.string())),
    containsLatex: z.optional(z.array(z.string())),
    containsPvc: z.optional(z.array(z.boolean())),
    energyAmount: z.optional(z.array(z.string())),
    fatAmount: z.optional(z.array(z.string())),
    fiberAmount: z.optional(z.array(z.string())),
    material: z.optional(z.array(z.string())),
    numberOfWashes: z.optional(z.array(z.string())),
    proteinAmount: z.optional(z.array(z.string())),
    ceMarkedProduct: z.optional(z.array(z.boolean())),
    bisphenol: z.optional(z.array(z.boolean())),
    lanolin: z.optional(z.array(z.boolean())),
    phthalates: z.optional(z.array(z.boolean())),
    plasticizer: z.optional(z.array(z.boolean())),
    resin: z.optional(z.array(z.boolean())),
    sterile: z.optional(z.array(z.boolean())),
    environmentalCode: z.optional(z.array(z.string())),
    absorptionCapacity: z.optional(z.array(z.string())),
    taste: z.optional(z.array(z.string())),
    tip: z.optional(z.array(z.string())),
    tubingLength: z.optional(z.array(z.string()))
});

export const zProductSearchFilterDto = z.object({
    category: z.optional(z.array(z.string())),
    contractIds: z.optional(z.array(z.string())),
    priceListIds: z.optional(z.array(z.string()))
});

/**
 * Quick search
 */
export const zQuickSearchQueryDto = z.object({
    query: z.string().min(3).max(2147483647),
    displayLocation: z.optional(z.string()),
    user: z.optional(z.string())
});

export const zSmallestUnitPriceDto = z.object({
    unitName: z.optional(z.string()),
    unitPrice: z.optional(z.number()),
    unitPriceWithVat: z.optional(z.number())
});

export const zProductPriceLineInputDto = z.object({
    productId: z.string(),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zBffPriceInputDto = z.object({
    siteId: z.optional(z.string()),
    currency: z.optional(z.string()),
    products: z.optional(z.array(zProductPriceLineInputDto))
});

export const zOrderHistoryQueryDto = z.object({
    productId: z.optional(z.string().min(0).max(255)),
    orderId: z.optional(z.string().min(0).max(255)),
    customerRef: z.optional(z.string().min(0).max(255)),
    dateFrom: z.optional(z.iso.datetime()),
    dateTo: z.optional(z.iso.datetime())
});

export const zDeliveryAddressDto = z.object({
    addressLine1: z.string().min(0).max(255),
    addressLine2: z.optional(z.string().min(0).max(255)),
    countryCode: z.string().length(2).regex(/^[A-Z]{2}$/),
    name: z.string().min(0).max(255),
    zipCode: z.string(),
    entryCode: z.optional(z.string()),
    city: z.string(),
    sourceAddressId: z.optional(z.string())
});

export const zInputOrderLineDto = z.object({
    productId: z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/),
    originalProductId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    appropriationId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zMarketingPermissionDto = z.object({
    permissionGiven: z.optional(z.boolean())
});

/**
 * Response wrapper containing product ID and associated favorite list IDs
 */
export const zFavoriteListIdsResponseDto = z.object({
    productIds: z.optional(z.string()),
    favoriteListIds: z.optional(z.array(z.uuid()))
});

/**
 * Request wrapper containing a list of product IDs
 */
export const zProductIdsRequestDto = z.object({
    productIds: z.optional(z.array(z.string()))
});

/**
 * FavoriteListEntity as persisted in the database (without items)
 */
export const zFavoriteListEntityDto = z.object({
    id: z.optional(z.uuid()),
    name: z.optional(z.string()),
    customerId: z.optional(z.string()),
    isDefault: z.optional(z.boolean()),
    creationDate: z.optional(z.iso.datetime()),
    createdBy: z.optional(z.string()),
    createdByUsername: z.optional(z.string()),
    lastModifiedDate: z.optional(z.iso.datetime()),
    lastModifiedBy: z.optional(z.string()),
    lastModifiedByUsername: z.optional(z.string())
});

/**
 * Request body for creating a new favorite list.
 */
export const zFavoriteListCreateRequestDto = z.object({
    name: z.optional(z.string()),
    productIds: z.optional(z.array(z.string()))
});

export const zCheckoutShippingMethodDto = z.object({
    supplyChainPartGroup: z.optional(z.string()),
    pickingLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    site: z.optional(z.string()),
    shipViaCode: z.optional(z.string()),
    routeId: z.optional(z.string()),
    defaultShipVia: z.optional(z.boolean()),
    deliveryLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zShippingMethodDto = z.object({
    pickingLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    site: z.optional(z.string()),
    shipViaCode: z.optional(z.string()),
    routeId: z.optional(z.string()),
    defaultShipVia: z.optional(z.boolean()),
    deliveryLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zShippingMethodExceptionDto = z.object({
    supplyChaingPartGroup: z.optional(z.string()),
    pickingLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    site: z.optional(z.string()),
    shipViaCode: z.optional(z.string()),
    routeId: z.optional(z.string()),
    defaultShipVia: z.optional(z.boolean()),
    deliveryLeadtime: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zCalculateCartLineInputDto = z.object({
    productId: z.string(),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
});

export const zUserInfoDto = z.object({
    id: z.optional(z.string()),
    customerId: z.optional(z.string()),
    firstName: z.optional(z.string()),
    lastName: z.optional(z.string()),
    displayUid: z.optional(z.string()),
    name: z.optional(z.string()),
    type: z.optional(z.string())
});

export const zAnonymousTokenResponseDto = z.object({
    token: z.optional(z.string())
});

export const zDeliveryNoteDto = z.object({
    deliveryNoteNo: z.optional(z.string()),
    fileName: z.optional(z.string())
});

export const zInvoiceLineDto = z.object({
    invoiceNo: z.optional(z.string()),
    fileName: z.optional(z.string())
});

export const zCustomerUserDataDto = z.object({
    username: z.optional(z.string()),
    name: z.optional(z.string()),
    email: z.optional(z.string()),
    phone: z.optional(z.string())
});

export const zCustomerPriceListDto = z.object({
    priceListIds: z.optional(z.array(z.string()))
});

export const zCustomerAgreementsResponseDto = z.object({
    customerAgreements: z.optional(z.array(z.string()))
});

export const zCustomerInfoDto = z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string()),
    type: z.optional(z.string())
});

/**
 * Market header. Allowed values: DK_B2B, DK_B2C, FI_B2B, FI_B2C, NO_B2B, NO_B2C, SE_B2B, SE_B2C
 */
export const zCountryMarketEnum = z.enum([
    'DK_B2B',
    'DK_B2C',
    'FI_B2B',
    'FI_B2C',
    'NO_B2B',
    'NO_B2C',
    'SE_B2B',
    'SE_B2C'
]);

/**
 * Role header. Allowed values: ANONYMOUS, EMPLOYEE, CUSTOMER
 */
export const zRoleValueEnum = z.enum([
    'ANONYMOUS',
    'EMPLOYEE',
    'CUSTOMER'
]);

export const zSchemaEnum = z.enum(['DK_B2B', 'DK_B2C']);

/**
 * Type of the image, can be PRIMARY or GALLERY
 */
export const zImageTypeEnum = z.enum(['PRIMARY', 'GALLERY']);

export const zImageDto = z.object({
    imageType: z.optional(zImageTypeEnum),
    format: z.optional(z.string()),
    url: z.optional(z.string()),
    altText: z.optional(z.string()),
    galleryIndex: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zSortDirectionEnum = z.enum(['DESC', 'ASC']);

export const zPaginationDto = z.object({
    page: z.optional(z.int().gte(0).lte(2147483647)),
    pageSize: z.optional(z.int().gte(0).lte(2147483647)),
    sortBy: z.optional(z.string().min(0).max(255).regex(/^[0-9a-zA-Z._-]+$/)),
    sortDirection: z.optional(zSortDirectionEnum),
    totalPages: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    totalResults: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9223372036854776000)))
});

export const zPageableDto = z.object({
    page: z.optional(z.int().gte(0).lte(2147483647)),
    pageSize: z.optional(z.int().gte(0).lte(2147483647)),
    sortBy: z.optional(z.string().min(0).max(255).regex(/^[0-9a-zA-Z._-]+$/)),
    sortDirection: z.optional(zSortDirectionEnum)
});

/**
 * Product search
 */
export const zProductSearchQueryDto = z.object({
    query: z.optional(z.string()),
    displayLocation: z.optional(z.string()),
    user: z.optional(z.string()),
    facets: z.optional(zProductSearchFacetDto),
    filters: z.optional(zProductSearchFilterDto),
    pageable: z.optional(zPageableDto)
});

export const zHistoryQueryDto = z.object({
    orderHistoryQuery: z.optional(zOrderHistoryQueryDto),
    pagination: z.optional(zPageableDto)
});

export const zFavoriteListsListDto = z.object({
    results: z.optional(z.array(zFavoriteListEntityDto).min(0).max(2000)),
    pagination: z.optional(zPaginationDto)
});

/**
 * Get customer positive list
 */
export const zPositiveListSearchQueryDto = z.object({
    siteId: z.optional(z.string().min(1).max(10).regex(/^[0-9a-zA-Z_-]{1,10}$/)),
    pagination: z.optional(zPaginationDto)
});

/**
 * Type of the price
 */
export const zPriceTypeEnum = z.enum([
    'BUY',
    'FROM',
    'BASE',
    'SCALED',
    'CONTRACT',
    'DISCOUNT_NORMAL',
    'DISCOUNT_CAMPAIGN',
    'DISCOUNT_SCALEDCAMPAIGN',
    'DISCOUNT_PROMOTION'
]);

/**
 * Representation of a Price
 */
export const zPriceDto = z.object({
    currencyIso: z.optional(z.string()),
    value: z.optional(z.number()),
    priceType: z.optional(zPriceTypeEnum),
    formattedValue: z.optional(z.string()),
    minQuantity: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9223372036854776000))),
    maxQuantity: z.optional(z.coerce.bigint().gte(BigInt(0)).lte(BigInt(9223372036854776000))),
    campaignCode: z.optional(z.string())
});

/**
 * Representation of a Price Range
 */
export const zPriceRangeDto = z.object({
    maxPrice: z.optional(zPriceDto),
    minPrice: z.optional(zPriceDto)
});

export const zTypeEnum = z.enum(['RADIO', 'CHECKBOX']);

export const zProductSearchFacetMetadataResultDto = z.object({
    type: z.optional(zTypeEnum),
    priority: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zProductSearchFacetMetadataResultListDto = z.object({
    category: z.optional(zProductSearchFacetMetadataResultDto),
    brand: z.optional(zProductSearchFacetMetadataResultDto),
    stockAvailability: z.optional(zProductSearchFacetMetadataResultDto),
    size: z.optional(zProductSearchFacetMetadataResultDto),
    balloonVolume: z.optional(zProductSearchFacetMetadataResultDto),
    carbAmount: z.optional(zProductSearchFacetMetadataResultDto),
    ch: z.optional(zProductSearchFacetMetadataResultDto),
    color: z.optional(zProductSearchFacetMetadataResultDto),
    containsLatex: z.optional(zProductSearchFacetMetadataResultDto),
    containsPvc: z.optional(zProductSearchFacetMetadataResultDto),
    energyAmount: z.optional(zProductSearchFacetMetadataResultDto),
    fatAmount: z.optional(zProductSearchFacetMetadataResultDto),
    fiberAmount: z.optional(zProductSearchFacetMetadataResultDto),
    material: z.optional(zProductSearchFacetMetadataResultDto),
    numberOfWashes: z.optional(zProductSearchFacetMetadataResultDto),
    proteinAmount: z.optional(zProductSearchFacetMetadataResultDto),
    ceMarkedProduct: z.optional(zProductSearchFacetMetadataResultDto),
    bisphenol: z.optional(zProductSearchFacetMetadataResultDto),
    lanolin: z.optional(zProductSearchFacetMetadataResultDto),
    phthalates: z.optional(zProductSearchFacetMetadataResultDto),
    plasticizer: z.optional(zProductSearchFacetMetadataResultDto),
    resin: z.optional(zProductSearchFacetMetadataResultDto),
    sterile: z.optional(zProductSearchFacetMetadataResultDto),
    environmentalCode: z.optional(zProductSearchFacetMetadataResultDto),
    absorptionCapacity: z.optional(zProductSearchFacetMetadataResultDto),
    taste: z.optional(zProductSearchFacetMetadataResultDto),
    tip: z.optional(zProductSearchFacetMetadataResultDto),
    tubingLength: z.optional(zProductSearchFacetMetadataResultDto)
});

export const zProductStockEnum = z.enum([
    'STOCK_REGULAR_WITHOUT_QUANTITY',
    'STOCK_REGULAR_WITH_QUANTITY',
    'NON_STOCK_WITHOUT_QUANTITY',
    'NON_STOCK_WITH_QUANTITY',
    'NON_STOCK_DIRECT_WITH_QUANTITY',
    'UNKNOWN'
]);

export const zProductWebshopStatusEnum = z.enum([
    'COMPOSABLE_A',
    'COMPOSABLE_B',
    'COMPOSABLE_C',
    'COMPOSABLE_D',
    'COMPOSABLE_E',
    'COMPOSABLE_F',
    'COMPOSABLE_G',
    'NO'
]);

export const zProductPartStatusEnum = z.enum([
    'A',
    'O',
    'P',
    'D',
    'S',
    'T',
    'N',
    'UNKNOWN'
]);

export const zStockLevelStatusEnum = z.enum([
    'inStock',
    'outOfStock',
    'lowStock',
    'backOrder',
    'preOrder',
    'notSpecified'
]);

/**
 * Representation of a Stock
 */
export const zStockDto = z.object({
    stockLevelStatus: zStockLevelStatusEnum,
    stockLevel: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    isValueRounded: z.boolean()
});

/**
 * Representation of a Future Stock
 */
export const zFutureStockDto = z.object({
    stock: z.optional(zStockDto),
    date: z.optional(z.iso.datetime()),
    formattedDate: z.optional(z.string())
});

/**
 * Representation of a Product
 */
export const zSilWebProductDto = z.object({
    code: z.optional(z.string()),
    name: z.optional(z.string()),
    lastOrderDate: z.optional(z.iso.datetime()),
    lastOrderQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    desiredQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    url: z.optional(z.string()),
    description: z.optional(z.string()),
    purchasable: z.optional(z.boolean()),
    stock: z.optional(zStockDto),
    futureStocks: z.optional(z.array(zFutureStockDto)),
    availableForPickup: z.optional(z.boolean()),
    averageRating: z.optional(z.number()),
    numberOfReviews: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    summary: z.optional(z.string()),
    manufacturer: z.optional(z.string()),
    variantType: z.optional(z.string()),
    price: z.optional(zPriceDto),
    sapUnit: z.optional(zSapUnitDto),
    baseProduct: z.optional(z.string()),
    images: z.optional(z.array(zImageDto)),
    categories: z.optional(z.array(zCategoryDto)),
    reviews: z.optional(z.array(zReviewDto)),
    classifications: z.optional(z.array(zClassificationDto)),
    potentialPromotions: z.optional(z.array(zPromotionDto)),
    variantOptions: z.optional(z.array(zVariantOptionDto)),
    baseOptions: z.optional(z.array(zBaseOptionDto)),
    volumePricesFlag: z.optional(z.boolean()),
    volumePrices: z.optional(z.array(zPriceDto)),
    productReferences: z.optional(z.array(zProductReferenceDto)),
    variantMatrix: z.optional(z.array(zVariantMatrixElementDto)),
    priceRange: z.optional(zPriceRangeDto),
    multidimensional: z.optional(z.boolean()),
    configuratorType: z.optional(z.string()),
    configurable: z.optional(z.boolean()),
    tags: z.optional(z.array(z.string())),
    sapAddToCartDisabled: z.optional(z.boolean()),
    sapAddToCartDisabledMessage: z.optional(z.string()),
    firstVariantCode: z.optional(z.string()),
    firstVariantImage: z.optional(z.string()),
    timedAccessPromotion: z.optional(zPromotionDto),
    source: z.optional(z.string()),
    productType: z.optional(z.string()),
    packagingDescription: z.optional(z.string()),
    sizeDescription: z.optional(z.string()),
    size: z.optional(z.string()),
    packageQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    packageUnit: z.optional(z.string()),
    packageSalesUnit: z.optional(z.string()),
    basePrice: z.optional(zPriceDto),
    appropriated: z.optional(z.boolean()),
    contracted: z.optional(z.boolean()),
    salesUnits: z.optional(zSalesUnitsDto),
    documents: z.optional(z.array(zProductDocumentDto)),
    supplierAlternativeAID: z.optional(z.string()),
    discountedPrice: z.optional(zPriceDto),
    volumeDiscountsFlag: z.optional(z.boolean()),
    volumeDiscounts: z.optional(z.array(zPriceDto)),
    inFavoriteList: z.optional(z.boolean()),
    productDatasheet: z.optional(zProductDocumentDto),
    technicalDatasheet: z.optional(zProductDocumentDto),
    safetyDatasheet: z.optional(zProductDocumentDto),
    brochures: z.optional(z.array(zProductDocumentDto)),
    userManuals: z.optional(z.array(zProductDocumentDto)),
    certificates: z.optional(z.array(zProductDocumentDto)),
    productStock: z.optional(zProductStockEnum),
    productWebshopStatus: z.optional(zProductWebshopStatusEnum),
    productPartStatus: z.optional(zProductPartStatusEnum),
    e6ProductId: z.optional(z.string()),
    ceMarking: z.optional(z.boolean()),
    ceExpiryDate: z.optional(z.string()),
    contentUnit: z.optional(z.string()),
    ean: z.optional(z.string()),
    mediqClassifications: z.optional(z.array(zMediqClassificationDto)),
    nonInventoryParts: z.optional(z.array(zProductNonInventoryPartDto)),
    inPositiveList: z.optional(z.boolean()),
    limitPerOrder: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }))
});

export const zProductSearchResultDto = z.object({
    results: z.optional(z.array(zSilWebProductDto)),
    facets: z.optional(zProductSearchFacetResultListDto),
    facetMetadata: z.optional(zProductSearchFacetMetadataResultListDto),
    pagination: z.optional(zPaginationDto)
});

export const zQuickSearchResultDto = z.object({
    products: z.optional(z.array(zSilWebProductDto)),
    categories: z.optional(z.array(zProductSearchFacetResultDto))
});

/**
 * Favorite list with full product data and pagination
 */
export const zFavoriteListResponseFullDto = z.object({
    id: z.optional(z.uuid()),
    name: z.optional(z.string()),
    customerId: z.optional(z.string()),
    products: z.optional(z.array(zSilWebProductDto)),
    pagination: z.optional(zPaginationDto),
    creationDate: z.optional(z.iso.datetime()),
    createdBy: z.optional(z.string()),
    lastModifiedDate: z.optional(z.iso.datetime()),
    lastModifiedBy: z.optional(z.string()),
    default: z.optional(z.boolean())
});

export const zPositiveListResponseDto = z.object({
    agreementId: z.optional(z.string().min(0).max(255)),
    results: z.optional(z.array(zSilWebProductDto)),
    pagination: z.optional(zPaginationDto)
});

/**
 * Discount row type
 */
export const zDiscountRowTypeEnum = z.enum([
    'APPROPRIATION',
    'GREEN_ORDINATION',
    'AGREEMENT_GROUP',
    'CAMPAIGN_PART',
    'CAMPAIGN_SALES_PROMOTION_PART',
    'CAMPAIGN_SALES_PROMOTION_NODE'
]);

export const zDiscountAppliedDto = z.object({
    id: z.optional(z.string()),
    percentage: z.optional(z.number()),
    fixPrice: z.optional(z.number()),
    minimumQuantityNeeded: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    quantityOrdered: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    minimumApplicableQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    discountSourceId: z.optional(z.string()),
    startDate: z.optional(z.iso.datetime()),
    endDate: z.optional(z.iso.datetime()),
    discountRowType: z.optional(zDiscountRowTypeEnum),
    assortmentNode: z.optional(z.string()),
    isNettable: z.optional(z.boolean()),
    isApplied: z.optional(z.boolean())
});

/**
 * Type of price
 */
export const zPriceTypeEnum2 = z.enum([
    'AGREEMENT',
    'AGREEMENT_GROUP',
    'APPROPRIATION',
    'PRICE_LIST',
    'POSITIVE_LIST',
    'CAMPAIGN'
]);

export const zPriceValueDto = z.object({
    productId: z.optional(z.string()),
    quantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    value: z.optional(z.number()),
    valueWithVat: z.optional(z.number()),
    totalValue: z.optional(z.number()),
    totalValueWithVat: z.optional(z.number()),
    fullValue: z.optional(z.number()),
    fullValueWithVat: z.optional(z.number()),
    fullTotalValue: z.optional(z.number()),
    fullTotalValueWithVat: z.optional(z.number()),
    vatPercentage: z.optional(z.number()),
    currency: z.optional(z.string()),
    discountAppliedId: z.optional(z.string()),
    netto: z.optional(z.boolean()),
    priorityPrice: z.optional(z.boolean()),
    priceType: z.optional(zPriceTypeEnum2),
    discountRowType: z.optional(zDiscountRowTypeEnum),
    smallestUnitPrice: z.optional(zSmallestUnitPriceDto),
    discountApplied: z.optional(z.array(zDiscountAppliedDto))
});

export const zProductPriceDto = z.object({
    productId: z.optional(z.string()),
    quantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    validPrices: z.optional(z.array(zPriceValueDto))
});

export const zProductsPriceResponseDto = z.object({
    siteId: z.optional(z.string()),
    validPrices: z.optional(z.array(zPriceValueDto)),
    productPrices: z.optional(z.array(zProductPriceDto))
});

export const zStatusEnum = z.enum([
    'RELEASED',
    'BLOCKED',
    'RESERVED',
    'PICKED',
    'PARTIALLY_DELIVERED',
    'DELIVERED',
    'CANCELLED',
    'PLANNED',
    'INVOICED',
    'CLOSED'
]);

export const zOrderSummaryDto = z.object({
    id: z.string(),
    clientOrderId: z.string(),
    customerOrderRef: z.optional(z.string()),
    creationDate: z.iso.datetime(),
    wantedDeliveryDate: z.iso.datetime(),
    status: zStatusEnum,
    invoices: z.array(z.string()),
    totalGrossAmount: z.number(),
    totalNetAmount: z.number()
});

export const zOrderSummaryListDto = z.object({
    results: z.array(zOrderSummaryDto).min(0).max(1000),
    pagination: zPaginationDto
});

export const zOrderLineDto = z.object({
    product: z.optional(zSilWebProductDto),
    productId: z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/),
    lineNo: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    relNo: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    quantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    uom: z.optional(z.string()),
    status: z.optional(zStatusEnum),
    saleUnitPrice: z.optional(z.number()),
    netAmount: z.optional(z.number()),
    grossAmount: z.optional(z.number()),
    taxAmount: z.optional(z.number()),
    plannedDeliveryDate: z.optional(z.iso.datetime()),
    deliveredQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    description: z.optional(z.string()),
    traceLinks: z.optional(z.array(z.string())),
    demandRefNo: z.optional(z.string()),
    demandLineNo: z.optional(z.string()),
    demandDeliveryNo: z.optional(z.string()),
    demandType: z.optional(z.string()),
    originalProductId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    appropriationId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/))
});

export const zPaymentMethodEnum = z.enum([
    'INVOICE',
    'CREDIT_CARD',
    'PBS'
]);

export const zOrderTypeEnum = z.enum([
    'B2B',
    'B2P',
    'NO'
]);

export const zOrderSourceEnum = z.enum([
    'WEBSHOP_DK_B2B',
    'WEBSHOP_DK_B2C',
    'WEBSHOP_DK_B2A',
    'WEBSHOP_NO_B2B',
    'WEBSHOP_NO_B2C',
    'WEBSHOP_NO_B2A',
    'WEBSHOP_SE_B2B',
    'WEBSHOP_SE_B2C',
    'WEBSHOP_SE_B2A',
    'WEBSHOP_FI_B2B',
    'WEBSHOP_FI_B2C',
    'WEBSHOP_FI_B2A',
    'UNKNOWN'
]);

/**
 * Order to be created
 */
export const zUpsertOrderInputDto = z.object({
    clientOrderId: z.string(),
    customerId: z.string().min(0).max(255),
    wantedDeliveryDate: z.optional(z.iso.datetime()),
    contract: z.optional(z.string()),
    note: z.optional(z.string()),
    externalLabelNote: z.optional(z.string()),
    shipViaCode: z.optional(z.string().min(1).max(10).regex(/^[0-9a-zA-Z_-]{1,5}$/)),
    entryCode: z.optional(z.string()),
    currency: z.optional(z.string().length(3)),
    customerOrderRef: z.optional(z.string().min(0).max(255)),
    paymentMethod: z.optional(zPaymentMethodEnum),
    paymentHandle: z.optional(z.string().min(0).max(255)),
    orderType: z.optional(zOrderTypeEnum),
    paymentTransactionNo: z.optional(z.string().min(0).max(255)),
    parcelLockerId: z.optional(z.string().min(0).max(255)),
    deliveryAddressId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    phone: z.optional(z.string().min(0).max(255)),
    email: z.optional(z.string().min(0).max(255)),
    orderSource: z.optional(zOrderSourceEnum),
    webShopUser: z.optional(z.string().min(0).max(255)),
    webShopUserRef: z.optional(z.string().min(0).max(255)),
    orderLines: z.array(zInputOrderLineDto).min(1).max(1000),
    deliveryAddress: z.optional(zDeliveryAddressDto)
});

export const zOrderDto = z.object({
    id: z.string(),
    sourceId: z.string(),
    source: z.string(),
    clientOrderId: z.string(),
    customerOrderRef: z.string(),
    orderType: zOrderTypeEnum,
    customerId: z.string().min(0).max(255),
    wantedDeliveryDate: z.iso.datetime(),
    creationDate: z.iso.datetime(),
    note: z.string(),
    externalLabelNote: z.string(),
    status: zStatusEnum,
    currency: z.string(),
    paymentMethod: zPaymentMethodEnum,
    totalNetAmount: z.number(),
    totalGrossAmount: z.number(),
    paymentTransactionNo: z.string().min(0).max(255),
    parcelLockerId: z.string().min(0).max(255),
    phone: z.string().min(0).max(255),
    email: z.string().min(0).max(255),
    orderSource: zOrderSourceEnum,
    webShopUser: z.string().min(0).max(255),
    webShopUserRef: z.string().min(0).max(255),
    invoices: z.array(z.string()),
    invoiceLines: z.array(zInvoiceLineDto),
    deliveryNotes: z.array(z.string()),
    deliveryNoteLines: z.array(zDeliveryNoteDto),
    deliveryAddressId: z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/),
    deliveryAddress: zDeliveryAddressDto,
    billingAddress: zDeliveryAddressDto,
    orderLines: z.array(zOrderLineDto).min(1).max(1000)
});

export const zCustomerTypeEnum = z.enum(['CONSUMER', 'BUSINESS']);

/**
 * Update marketing permissions
 */
export const zMarketingPermissionRequestDto = z.object({
    permissionGiven: z.optional(z.boolean()),
    customerId: z.optional(z.string()),
    phone: z.optional(z.string()),
    customerType: z.optional(zCustomerTypeEnum)
});

/**
 * Sort option: NAME_ASC, NAME_DESC, CREATED_DATE_ASC, CREATED_DATE_DESC
 */
export const zSortByEnum = z.enum([
    'NAME_ASC',
    'NAME_DESC',
    'CREATED_DATE_ASC',
    'CREATED_DATE_DESC'
]);

/**
 * Pagination with sortBy constrained to supported SortOption values
 */
export const zPageableWithSortOption = z.object({
    page: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    pageSize: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    sortBy: z.optional(zSortByEnum)
});

/**
 * Search, sorting and pagination for favorite lists
 */
export const zFavoriteListsSearchQueryDto = z.object({
    pageable: z.optional(zPageableWithSortOption),
    searchQuery: z.optional(z.string()),
    searchCreatedBy: z.optional(z.string())
});

/**
 * Sort option: NAME_ASC, NAME_DESC, NUMBER_ASC, NUMBER_DESC
 */
export const zSortByEnum2 = z.enum([
    'NAME_ASC',
    'NAME_DESC',
    'NUMBER_ASC',
    'NUMBER_DESC'
]);

/**
 * Pagination with sortBy constrained to supported SortOption values
 */
export const zPageableWithSortOptionFull = z.object({
    page: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    pageSize: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    sortBy: z.optional(zSortByEnum2)
});

/**
 * Query parameters for fetching full favorite list with filtering, sorting and pagination
 */
export const zFavoriteListFullSearchQueryDto = z.object({
    pageable: z.optional(zPageableWithSortOptionFull),
    searchQuery: z.optional(z.string()),
    topLevelCategory: z.optional(z.array(z.string())),
    brand: z.optional(z.array(z.string())),
    size: z.optional(z.array(z.string()))
});

export const zMethodEnum = z.enum(['PHONE', 'E_MAIL']);

export const zCommMethodDto = z.object({
    method: z.optional(zMethodEnum),
    isDefault: z.optional(z.boolean()),
    isAddressDefault: z.optional(z.boolean()),
    value: z.optional(z.string())
});

export const zPurposeEnum = z.enum([
    'BILLING',
    'SHIPPING',
    'CONTACT'
]);

export const zCustomerAddressUsageDto = z.object({
    isDefault: z.optional(z.boolean()),
    purpose: z.optional(zPurposeEnum)
});

export const zCustomerAddressDto = z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string().min(0).max(255)),
    addressLine1: z.optional(z.string().min(0).max(255)),
    addressLine2: z.optional(z.string().min(0).max(255)),
    addressLine3: z.optional(z.string().min(0).max(255)),
    addressLine4: z.optional(z.string().min(0).max(255)),
    addressLine5: z.optional(z.string().min(0).max(255)),
    addressLine6: z.optional(z.string().min(0).max(255)),
    postalCode: z.optional(z.string()),
    entryCode: z.optional(z.string()),
    city: z.optional(z.string()),
    countryCode: z.optional(z.string().length(2).regex(/^[A-Z]{2}$/)),
    regionCode: z.optional(z.string().min(0).max(255)),
    districtCode: z.optional(z.string().min(0).max(255)),
    formatedAddress: z.optional(z.string()),
    shippingCostCode: z.optional(z.string()),
    commMethods: z.optional(z.array(zCommMethodDto).min(0).max(1000)),
    usage: z.optional(z.array(zCustomerAddressUsageDto).min(0).max(1000)),
    shippingMethods: z.optional(z.array(zShippingMethodDto).min(0).max(1000)),
    shippingMethodExceptions: z.optional(z.array(zShippingMethodExceptionDto).min(0).max(1000)),
    checkoutShippingMethods: z.optional(z.array(zCheckoutShippingMethodDto).min(0).max(1000))
});

export const zCustomerAddressesResponseDto = z.object({
    addresses: z.optional(z.array(zCustomerAddressDto))
});

/**
 * Customer address to be created/updated
 */
export const zCustomerAddressInputDto = z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string().min(0).max(255)),
    addressLine1: z.optional(z.string().min(0).max(255)),
    addressLine2: z.optional(z.string().min(0).max(255)),
    postalCode: z.optional(z.string()),
    entryCode: z.optional(z.string()),
    city: z.optional(z.string()),
    shippingCostCode: z.optional(z.string()),
    commMethods: z.optional(z.array(zCommMethodDto).min(0).max(1000)),
    usage: z.optional(z.array(zCustomerAddressUsageDto).min(0).max(1000))
});

export const zCustomerDataDto = z.object({
    id: z.optional(z.string()),
    customerId: z.optional(z.string()),
    name: z.optional(z.string()),
    email: z.optional(z.string()),
    phone: z.optional(z.string()),
    paymentMethods: z.optional(z.array(zPaymentMethodEnum)),
    addresses: z.optional(z.array(zCustomerAddressDto))
});

export const zCustomerProfileInfoDto = z.object({
    customerData: z.optional(zCustomerDataDto),
    userData: z.optional(zCustomerUserDataDto)
});

export const zDefaultAddressTypeEnum = z.enum(['DEFAULT_BILLING', 'DEFAULT_SHIPPING']);

/**
 * Retrieves addresses for given customer
 */
export const zCustomerAddressesQueryDto = z.object({
    addressType: z.optional(zPurposeEnum),
    defaultAddressType: z.optional(zDefaultAddressTypeEnum)
});

export const zUseEnum = z.enum(['TOTAL_VALUE', 'UNIT_PRICE']);

export const zCartLineDiscountAppliedDto = z.object({
    id: z.optional(z.string()),
    value: z.optional(z.number()),
    valueWithVat: z.optional(z.number()),
    use: z.optional(zUseEnum)
});

export const zCartLineDto = z.object({
    unitPrice: z.optional(z.number()),
    unitPriceWithVat: z.optional(z.number()),
    total: z.optional(z.number()),
    totalWithVat: z.optional(z.number()),
    fullUnitPrice: z.optional(z.number()),
    fullUnitPriceWithVat: z.optional(z.number()),
    fullTotal: z.optional(z.number()),
    fullTotalWithVat: z.optional(z.number()),
    vatPercentage: z.optional(z.number()),
    discountAppliedId: z.optional(z.string()),
    netto: z.optional(z.boolean()),
    currency: z.optional(z.string()),
    priceType: z.optional(zPriceTypeEnum2),
    discountRowType: z.optional(zDiscountRowTypeEnum),
    productId: z.optional(z.string()),
    quantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    discountApplied: z.optional(zCartLineDiscountAppliedDto),
    smallestUnitPrice: z.optional(zSmallestUnitPriceDto)
});

export const zCalculateCartResponseDto = z.object({
    total: z.optional(z.number()),
    totalWithVat: z.optional(z.number()),
    delivery: z.optional(z.number()),
    deliveryWithVat: z.optional(z.number()),
    deliveryChargeSource: z.optional(z.string()),
    cartTotal: z.optional(z.number()),
    cartTotalWithVat: z.optional(z.number()),
    availableDeliveryDates: z.optional(z.array(z.string())),
    lines: z.optional(z.array(zCartLineDto))
});

export const zBusinessTypeEnum = z.enum([
    'B2A',
    'B2B',
    'B2C'
]);

/**
 * Request body for cart calculation
 */
export const zCalculateCartInputDto = z.object({
    businessType: z.optional(zBusinessTypeEnum),
    siteId: z.optional(z.string()),
    currency: z.string(),
    deliveryAddressId: z.optional(z.string().min(3).max(5)),
    shipViaCode: z.optional(z.string()),
    lines: z.array(zCalculateCartLineInputDto)
});

export const zPrescriptionTypeEnum = z.enum([
    'NUTRITION',
    'MISCELLANEOUS',
    'INCONTINENCE',
    'DIABETES',
    'DIABETES_TYPE_1',
    'DIABETES_TYPE_2',
    'OSTOMY',
    'RESPIRATORY',
    'STOCKINGS',
    'DIETARY_SUPPLEMENTS',
    'HALF_NUTRITION',
    'FULL_NUTRITION',
    'GLUTEN_PRODUCT',
    'DEDUCTIBLE',
    'NURSING',
    'ACCESSORIES_NUTRITION',
    'CVK',
    'UNKNOWN'
]);

export const zMediqFlagEnum = z.enum([
    'APPROPRIATION',
    'GREEN_ORDINATION',
    'PROJECT',
    'EMPTY'
]);

export const zStateEnum = z.enum([
    'RELEASED',
    'REVISED',
    'PLANNED',
    'CANCELLED',
    'CLOSED',
    'REJECTED',
    'WON',
    'LOST'
]);

export const zProductTypeEnum = z.enum(['PRODUCT', 'GROUP']);

export const zPeriodEnum = z.enum([
    'AS_NEEDED',
    'DAILY',
    'MONTHLY',
    'ONCE',
    'WEEKLY',
    'YEARLY'
]);

export const zStatusEnum2 = z.enum([
    'CLOSED',
    'PLANNED',
    'RELEASED',
    'CUSTOMER_ORDER_CREATED',
    'CANCELLED',
    'REJECTED',
    'WON',
    'REVISED',
    'LOST'
]);

export const zAppropriationLineDto = z.object({
    productPrice: z.optional(z.unknown()),
    product: z.optional(zSilWebProductDto),
    lineId: z.optional(z.string().min(0).max(255)),
    releaseId: z.optional(z.string().min(0).max(255)),
    productId: z.string().min(0).max(255),
    productType: z.optional(zProductTypeEnum),
    buyQuantity: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
    isOriginalPrescriptionLine: z.optional(z.boolean()),
    period: z.optional(zPeriodEnum),
    periodFrequency: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    remainingQuantity: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    status: z.optional(zStatusEnum2),
    startDate: z.optional(z.string()),
    endDate: z.optional(z.string()),
    uom: z.optional(z.string().min(1).max(10).regex(/^[0-9a-zA-Z_-]{1,10}$/)),
    paymentRule: z.optional(z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })),
    isUnlimited: z.optional(z.boolean())
});

export const zAppropriationDto = z.object({
    id: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    source: z.optional(z.string()),
    sourceId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    appropriationId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    prescriptionType: z.optional(zPrescriptionTypeEnum),
    quoteType: z.optional(z.boolean()),
    customerQuoNo: z.optional(z.string().min(0).max(255)),
    contract: z.optional(z.string().min(0).max(255)),
    mediqFlag: z.optional(zMediqFlagEnum),
    quotationId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    customerId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    validFrom: z.optional(z.string()),
    validTo: z.optional(z.string()),
    prescriber: z.optional(z.string().min(0).max(255)),
    payingCustomerId: z.optional(z.string().min(1).max(255).regex(/^[0-9a-zA-Z_-]{1,255}$/)),
    agreementGroupId: z.optional(z.string().min(0).max(255)),
    renewable: z.optional(z.boolean()),
    comment: z.optional(z.string().min(0).max(255)),
    state: z.optional(zStateEnum),
    lines: z.optional(z.array(zAppropriationLineDto).min(0).max(1000))
});

export const zAppropriationListDto = z.object({
    results: z.optional(z.array(zAppropriationDto)),
    pagination: z.optional(zPaginationDto)
});

export const zAppropriationSearchQueryDto = z.object({
    productIds: z.optional(z.array(z.string().min(0).max(255))),
    productGroups: z.optional(z.array(z.string().min(1).max(2147483647))),
    appropriationStates: z.optional(z.array(zStateEnum)),
    lineStatuses: z.optional(z.array(zStatusEnum2))
});

/**
 * Get appropriations by given criteria
 */
export const zAppropriationSearchRequestDto = z.object({
    appropriationSearchQuery: z.optional(zAppropriationSearchQueryDto),
    pagination: z.optional(zPageableDto)
});

export const zRemoveProductFromFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        favoriteListId: z.uuid(),
        productId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zRemoveProductFromFavoriteListResponse = zFavoriteListResponseDto;

export const zAddProductToFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        favoriteListId: z.uuid(),
        productId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zAddProductToFavoriteListResponse = zFavoriteListResponseDto;

export const zUpdateDesiredQuantityData = z.object({
    body: zDesiredQuantityRequestDto,
    path: z.object({
        favoriteListId: z.uuid(),
        productId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zUpdateDesiredQuantityResponse = zFavoriteListResponseDto;

export const zEditFavoriteListData = z.object({
    body: zFavoriteListEditRquestDto,
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list edited
 */
export const zEditFavoriteListResponse = zFavoriteListResponseDto;

export const zProductSearchData = z.object({
    body: zProductSearchQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Product list
 */
export const zProductSearchResponse = zProductSearchResultDto;

export const zQuickSearchData = z.object({
    body: zQuickSearchQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Products and categories
 */
export const zQuickSearchResponse = zQuickSearchResultDto;

export const zGetPricesData = z.object({
    body: zBffPriceInputDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Products prices
 */
export const zGetPricesResponse = zProductsPriceResponseDto;

export const zGetCustomerOrderHistoryData = z.object({
    body: zHistoryQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Order summary list
 */
export const zGetCustomerOrderHistoryResponse = zOrderSummaryListDto;

export const zCreateOrderData = z.object({
    body: zUpsertOrderInputDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Order created successfully
 */
export const zCreateOrderResponse = zServerMessageDto;

export const zGetMarketingPermissionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        email: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Marketing permissions
 */
export const zGetMarketingPermissionsResponse = zMarketingPermissionDto;

export const zUpdateMarketingPermissionsData = z.object({
    body: zMarketingPermissionRequestDto,
    path: z.object({
        email: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Marketing permissions
 */
export const zUpdateMarketingPermissionsResponse = zMarketingPermissionDto;

export const zGetFavoriteListIdsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * List of favorite list IDs
 */
export const zGetFavoriteListIdsResponse = z.array(z.uuid());

export const zGetFavoriteListIdsByProductIdsData = z.object({
    body: zProductIdsRequestDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * List of product IDs and their associated favorite list IDs
 */
export const zGetFavoriteListIdsByProductIdsResponse = z.array(zFavoriteListIdsResponseDto);

export const zGetFavoriteListsData = z.object({
    body: zFavoriteListsSearchQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * List of favorite lists with pagination metadata
 */
export const zGetFavoriteListsResponse = zFavoriteListsListDto;

export const zAddProductsToFavoriteListData = z.object({
    body: zProductIdsRequestDto,
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zAddProductsToFavoriteListResponse = zFavoriteListResponseDto;

export const zGetFavoriteListFullData = z.object({
    body: zFavoriteListFullSearchQueryDto,
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list with products
 */
export const zGetFavoriteListFullResponse = zFavoriteListResponseFullDto;

export const zCopyFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list copied
 */
export const zCopyFavoriteListResponse = zFavoriteListResponseDto;

export const zAddProductToDefaultFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zAddProductToDefaultFavoriteListResponse = zFavoriteListResponseDto;

export const zAddProductsToDefaultFavoriteListData = z.object({
    body: zProductIdsRequestDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list updated
 */
export const zAddProductsToDefaultFavoriteListResponse = zFavoriteListResponseDto;

export const zGetDefaultFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Default favorite list
 */
export const zGetDefaultFavoriteListResponse = zFavoriteListResponseDto;

export const zCreateFavoriteListData = z.object({
    body: zFavoriteListCreateRequestDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list created
 */
export const zCreateFavoriteListResponse = zFavoriteListResponseDto;

export const zUpdateCustomerAddressData = z.object({
    body: zCustomerAddressInputDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Customer address updated successfully
 */
export const zUpdateCustomerAddressResponse = zCustomerAddressesResponseDto;

export const zGetCustomerAddressesData = z.object({
    body: zCustomerAddressesQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Information about customer
 */
export const zGetCustomerAddressesResponse = zCustomerAddressesResponseDto;

export const zCalculateCartData = z.object({
    body: zCalculateCartInputDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Calculated cart
 */
export const zCalculateCartResponse = zCalculateCartResponseDto;

export const zSearchAppropriationsData = z.object({
    body: zAppropriationSearchRequestDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Appropriations list
 */
export const zSearchAppropriationsResponse = zAppropriationListDto;

export const zContractedProductSearchData = z.object({
    body: zProductSearchQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Product list
 */
export const zContractedProductSearchResponse = zProductSearchResultDto;

export const zGetCustomerPositiveListData = z.object({
    body: zPositiveListSearchQueryDto,
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Agreements list
 */
export const zGetCustomerPositiveListResponse = zPositiveListResponseDto;

export const zGetCurrentUserData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Information about current user
 */
export const zGetCurrentUserResponse = zUserInfoDto;

export const zGetB2bUserData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Information about user
 */
export const zGetB2bUserResponse = zUserInfoDto;

export const zUserInfoData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * OK
 */
export const zUserInfoResponse = z.record(z.string(), z.unknown());

export const zGetAnonymousTokenData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Anonymous token
 */
export const zGetAnonymousTokenResponse = zAnonymousTokenResponseDto;

export const zPublicHelloData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * OK
 */
export const zPublicHelloResponse = z.string();

export const zGetOrderInvoicesAsZipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Successfully generated ZIP file
 */
export const zGetOrderInvoicesAsZipResponse = z.string();

export const zGetOrderDeliveryNotesAsZipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Successfully generated ZIP file
 */
export const zGetOrderDeliveryNotesAsZipResponse = z.string();

export const zGetOrderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Order
 */
export const zGetOrderResponse = zOrderDto;

export const zHelloData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * OK
 */
export const zHelloResponse = z.string();

export const zGetFavoriteListIdsByProductIdData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        productId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * List of favorite list IDs
 */
export const zGetFavoriteListIdsByProductIdResponse = z.array(z.uuid());

export const zDeleteFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Deleted
 */
export const zDeleteFavoriteListResponse = z.void();

export const zGetFavoriteListData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        favoriteListId: z.uuid()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Favorite list
 */
export const zGetFavoriteListResponse = zFavoriteListResponseDto;

export const zGetCustomerProfileData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Information about customer
 */
export const zGetCustomerProfileResponse = zCustomerProfileInfoDto;

export const zGetCustomerPriceListsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Agreements list
 */
export const zGetCustomerPriceListsResponse = zCustomerPriceListDto;

export const zGetCustomerAgreementsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Agreements list
 */
export const zGetCustomerAgreementsResponse = zCustomerAgreementsResponseDto;

export const zGetCustomerByIdData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Market': z.optional(zCountryMarketEnum),
        'X-Role': z.optional(zRoleValueEnum),
        'X-CustomerId': z.optional(z.string()),
        'X-OrgUnit': z.optional(z.string())
    }))
});

/**
 * Information about customer
 */
export const zGetCustomerByIdResponse = zCustomerInfoDto;
